<div class="flex flex-col">
  <div class="flex flex-row text-sm color-primary">
    <span>{{item()['kundengrp']}}</span>
  </div>
  <div class="flex flex-col">
    <span class="font-bold">{{item()['bezeichnung1']}}</span>
    <span class="">{{item()['bezeichnung2']}}</span>
    <span class="text-light">{{item()['bezeichnung']}}</span>
  </div>
</div>
